(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["categorias-carrossel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ss-category-carousel')) return;
    class CategoryCarousel extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.track = this.querySelector('.ss-categories__track');
        this.controls = this.querySelector('.ss-categories__controls');
        this.previous = this.querySelector('[data-category-previous]');
        this.next = this.querySelector('[data-category-next]');
        if (!this.track) return;
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { passive: true, signal });
        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('.ss-categories__item');
          if (card) card.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
        }, { signal });
        this.observer?.disconnect();
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        [...this.track.children].forEach((card) => this.observer.observe(card));
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      move(direction) {
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * (rtl ? -1 : 1) * this.track.clientWidth * .85, behavior: reduced ? 'instant' : 'smooth' });
      }
      update() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = max < 3;
        this.previous.disabled = position < 3;
        this.next.disabled = position >= max - 3;
        this.querySelector('.ss-categories__header').hidden = !this.querySelector('.ss-categories__title');
      }
    }
    customElements.define('ss-category-carousel', CategoryCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
